<template>
	<div class="row">
		<div class="col-md-4">
			<div class="card text-center mb-3">
				<h5 class="card-header">{{$t('header.change-admin-password')}}</h5>
				<div class="card-body">
					<form @submit.prevent="onChangeAdminPassword()">
						<div class="alert alert-info mb-3 text-center" role="alert"><strong>{{$t('text.attention')}}</strong> {{$t('text.warning.change-admin-password')}}</div>
						<div class="mb-3">
							<label for="inpAdminPassword" class="form-label">{{$t('label.new-admin-password')}}</label>
							<input type="text" class="form-control text-center font-monospace" id="inpAdminPassword" v-model="admin_password" required />
						</div>
						<div class="d-grid">
							<button class="btn btn-outline-primary" type="submit" :disabled="btnChangeAdminPasswordDisabled">{{$t('btn.change')}}</button>
						</div>
					</form>
					<div class="alert alert-warning alert-dismissible mt-3 mb-0 text-center" role="alert" v-if="changeAdminPasswordError">
						{{changeAdminPasswordError}}
						<button type="button" class="btn-close" aria-label="Close" @click="changeAdminPasswordError = ''"></button>
					</div>
				</div>
			</div>
		</div>
		<div class="col-md-4">
			<div class="card text-center mb-3">
				<h5 class="card-header">{{$t('header.change-editor-password')}}</h5>
				<div class="card-body">
					<form @submit.prevent="onChangeEditorPassword()">
						<div class="alert alert-info mb-3 text-center" role="alert"><strong>{{$t('text.attention')}}</strong> {{$t('text.warning.change-editor-password')}}</div>
						<div class="mb-3">
							<label for="inpEditorPassword" class="form-label">{{$t('label.new-editor-password')}}</label>
							<input type="text" class="form-control text-center font-monospace" id="inpEditorPassword" v-model="editor_password" required />
						</div>
						<div class="d-grid">
							<button class="btn btn-outline-primary" type="submit" :disabled="btnChangeEditorPasswordDisabled">{{$t('btn.change')}}</button>
						</div>
					</form>
					<div class="alert alert-warning alert-dismissible mt-3 mb-0 text-center" role="alert" v-if="changeEditorPasswordError">
						{{changeEditorPasswordError}}
						<button type="button" class="btn-close" aria-label="Close" @click="changeEditorPasswordError = ''"></button>
					</div>
				</div>
			</div>
		</div>
		<div class="col-md-4">
			<div class="card text-center mb-3">
				<h5 class="card-header">{{$t('header.change-exam-password')}}</h5>
				<div class="card-body">
					<form @submit.prevent="onChangeExamPassword()">
						<div class="alert alert-info mb-3 text-center" role="alert"><strong>{{$t('text.attention')}}</strong> {{$t('text.warning.change-exam-password')}}</div>
						<div class="mb-3">
							<label for="inpExamPassword" class="form-label">{{$t('label.new-exam-password')}}</label>
							<input type="text" class="form-control text-center font-monospace" id="inpExamPassword" v-model="exam_password" required />
						</div>
						<div class="d-grid">
							<button class="btn btn-outline-primary" type="submit" :disabled="btnChangeExamPasswordDisabled">{{$t('btn.change')}}</button>
						</div>
					</form>
					<div class="alert alert-warning alert-dismissible mt-3 mb-0 text-center" role="alert" v-if="changeExamPasswordError">
						{{changeExamPasswordError}}
						<button type="button" class="btn-close" aria-label="Close" @click="changeExamPasswordError = ''"></button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss">
      
</style>

<script>
import lib from '@/lib';
import { useMeta } from 'vue-meta';

export default {
	mixins: lib.mixins,
	setup(){
		useMeta({title: 'Настройки | KMIB EDU Admin'});
	},
	data: () => ({
		admin_password: '',
		btnChangeAdminPasswordDisabled: false,
		changeAdminPasswordError: '',
		
		editor_password: '',
		btnChangeEditorPasswordDisabled: false,
		changeEditorPasswordError: '',
		
		exam_password: '',
		btnChangeExamPasswordDisabled: false,
		changeExamPasswordError: '',
	}),
	methods: {
		async onChangeAdminPassword(){
			this.btnChangeAdminPasswordDisabled = true;
			this.changeAdminPasswordError = '';
			
			const res = await this.appModel.doChangeAdminPassword(this.admin_password);
			
			this.btnChangeAdminPasswordDisabled = false;
			if(res.success){
				this.admin_password = '';
				this.$router.push({path: '/logout'});
			} else {
				this.changeAdminPasswordError = res.error;
			}
		},
		async onChangeEditorPassword(){
			this.btnChangeEditorPasswordDisabled = true;
			this.changeEditorPasswordError = '';
			
			const res = await this.appModel.doChangeEditorPassword(this.editor_password);
			
			this.btnChangeEditorPasswordDisabled = false;
			if(res.success){
				this.editor_password = '';
			} else {
				this.changeEditorPasswordError = res.error;
			}
		},
		async onChangeExamPassword(){
			this.btnChangeExamPasswordDisabled = true;
			this.changeExamPasswordError = '';
			
			const res = await this.appModel.doChangeExamPassword(this.exam_password);
			
			this.btnChangeExamPasswordDisabled = false;
			if(res.success){
				this.exam_password = '';
			} else {
				this.changeExamPasswordError = res.error;
			}
		},
	},
	mounted(){
		this.appModel.pageTitle = 'title.settings';
		
		window.scrollTo(0, 0);
	},
	beforeMount(){
		if(this.authModel.isAuth()){
			if(this.authModel.isEditor()){
				this.$router.push({path: '/editor'});
			} else if(this.authModel.isStudent()){
				this.$router.push({path: '/'});
			}
		}
	},
	beforeRouteUpdate(to, from, next){
		//window.scrollTo(0, 0);
		next();
	},
};
</script>